import React, { Component } from "react";
import { FormGroup, FormControl, ControlLabel, Button } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Login.css";
import { Auth } from "aws-amplify";
import EstimatorNavBar from "../components/EstimatorNavBar";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      forgotPasswordDisplay: 0,
      forgotPasswordEmail: "",
      forgotPasswordCode: "",
      newPassword: "",
      isLoading: false,
      email: "",
      password: ""
    };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  validateResetPasswordForm() {
    return (
      this.state.forgotPasswordCode.length > 0 &&
      this.state.newPassword.length >= 8
    );
  }

  validateForgotPasswordForm() {
    return this.state.forgotPasswordEmail.length > 0;
  }

  sendResetPassword = async event => {
    try {
      await Auth.forgotPasswordSubmit(
        this.state.forgotPasswordEmail,
        this.state.forgotPasswordCode,
        this.state.newPassword
      );
      this.setState({ forgotPasswordDisplay: 0 });
    } catch (e) {
      alert(e.message);
      this.setState({ forgotPasswordDisplay: 2 });
    }
  };

  sendVerificationCode = async event => {
    try {
      await Auth.forgotPassword(this.state.forgotPasswordEmail);
    } catch (e) {
      alert(e.message);
      this.setState({ forgotPasswordDisplay: 1 });
    }
  };

  setForgotPasswordDisplay(e, status) {
    e.preventDefault();
    this.setState({ forgotPasswordDisplay: status });
    switch (status) {
      case 2:
        this.sendVerificationCode();
        break;
      case 3:
        this.sendResetPassword();

        break;
      default:
        break;
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      await Auth.signIn(this.state.email, this.state.password);
      this.props.userHasAuthenticated(true);
      this.props.history.push("/beta");
    } catch (e) {
      if (e.code === "UserNotConfirmedException") {
        if (
          window.confirm(
            "You need to validate your account before you can login. Please check your inbox and spam folder for a confirmation mail from support@digimasters.co.uk. Would you like to resend the validation email?"
          )
        ) {
          Auth.resendSignUp(this.state.email);
        }
      } else {
        alert(e.message);
      }
      this.setState({ isLoading: false });
    }
  };

  renderLoginForms() {
    switch (this.state.forgotPasswordDisplay) {
      case 1:
        return (
          <form onSubmit={this.handleForgotPasswordSubmit}>
            <Button
              bsStyle="link"
              bsSize="large"
              onClick={e => this.setForgotPasswordDisplay(e, 0)}
            >
              Back to Login
            </Button>
            <p>Please enter the email address you registered with.</p>
            <FormGroup controlId="forgotPasswordEmail" bsSize="large">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                autoFocus
                type="email"
                value={this.state.forgotPasswordEmail}
                onChange={this.handleChange}
              />
            </FormGroup>
            <Button
              block
              bsSize="large"
              disabled={!this.validateForgotPasswordForm()}
              onClick={e => this.setForgotPasswordDisplay(e, 2)}
            >
              Send Reset Instructions
            </Button>
          </form>
        );
      case 2:
        return (
          <form onSubmit={this.handleResetPasswordSubmit}>
            <Button
              bsStyle="link"
              bsSize="large"
              onClick={e => this.setForgotPasswordDisplay(e, 0)}
            >
              Back to Login
            </Button>
            <p>
              We have sent you an email with a verification code to reset your
              password. Please check your email and enter the code below.
            </p>
            <FormGroup controlId="resetPasswordEmail" bsSize="large">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                autoFocus
                type="email"
                value={this.state.forgotPasswordEmail}
                disabled
              />
            </FormGroup>
            <FormGroup controlId="newPassword" bsSize="large">
              <ControlLabel>New Password</ControlLabel>
              <FormControl
                value={this.state.newPassword}
                onChange={this.handleChange}
                type="password"
              />
              <p>
                Min. 8 characters with at least 1 number, 1 uppercase letter and
                1 lowercase letter
              </p>
            </FormGroup>
            <FormGroup controlId="forgotPasswordCode" bsSize="large">
              <ControlLabel>Verification Code</ControlLabel>
              <FormControl
                autoFocus
                type="tel"
                value={this.state.forgotPasswordCode}
                onChange={this.handleChange}
              />
            </FormGroup>
            <Button
              block
              bsSize="large"
              disabled={!this.validateResetPasswordForm()}
              onClick={e => this.setForgotPasswordDisplay(e, 3)}
            >
              Reset Password
            </Button>
          </form>
        );
      default:
        return (
          <form onSubmit={this.handleSubmit}>
            <FormGroup controlId="email" bsSize="large">
              <ControlLabel>Email</ControlLabel>
              <FormControl
                autoFocus
                type="email"
                value={this.state.email}
                onChange={this.handleChange}
              />
            </FormGroup>
            <FormGroup controlId="password" bsSize="large">
              <ControlLabel>Password</ControlLabel>
              <FormControl
                value={this.state.password}
                onChange={this.handleChange}
                type="password"
              />
            </FormGroup>
            <LoaderButton
              block
              bsSize="large"
              disabled={!this.validateForm()}
              type="submit"
              isLoading={this.state.isLoading}
              text="Login"
              loadingText="Logging in…"
            />
            <Button
              block
              bsSize="large"
              bsStyle="link"
              onClick={e => this.setForgotPasswordDisplay(e, 1)}
            >
              Forgot Password?
            </Button>
          </form>
        );
    }
  }

  render() {
    return (
      <div>
        <EstimatorNavBar
          isAuthenticated={this.props.isAuthenticated}
          appLogout={this.props.appLogout}
        />
        <div className="Login">{this.renderLoginForms()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Login.js